<template>
  <knowledge-view
    class="bg-gray-1"
    :custom-width="width"
    @go-to-entity="goToEntity"
    @empty-view="fixEmptyView"
  >
  </knowledge-view>
</template>

<script setup lang="ts">
import useEntities from '@commons/composables/useEntities'

const configStore = useConfigStore()
const { width } = storeToRefs(configStore)

const { goToEntity } = useEntities()
const { fixEmptyView } = useApp()
</script>
